<template>
    <div class="pt-4">
        <DataTable :value="previousEnrolledTutors" class="p-datatable-sm" paginator :rows="rowsPerPage"
            :rowsPerPageOptions="[5, 10, 20, 50]" @page="onPageChange">
            <Column v-for="(col, index) in columns" :key="index" :field="col.field" :header="col.header"
                :sortable=col.sortable class="whitespace-nowrap" :bodyStyle="{ whiteSpace: 'nowrap' }">
                <template #body="{ data }">
                    {{ col.field === 'tutorType' ? cleanupLables(data[col.field]) : data[col.field] }}
                </template>
            </Column>
            <Column field="chatHistory" header="Chat history">
                <template #body="{ data }">
                    <Button v-model="data.chatHistory" icon="pi pi-comments" label=""
                        class="p-button-text Caption mb-2 black-btn " />
                </template>
            </Column>
            <template #paginatorstart>
                <div class="text-sm text-gray-700">
                    <!-- Showing {{ rowsPerPage }} of {{ tableData.length }} records -->
                </div>
            </template>
            <template #empty>
                <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
                    <div class="text-center">
                        <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                        <p class="mt-2 text-color-secondary">No Data found</p>
                    </div>
                </div>
            </template>
        </DataTable>
    </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { cleanupLables } from "@/utils/cleanups";
defineProps({
    previousEnrolledTutors: null,
})
// const totalRecords = ref(0);       
const currentPage = ref(0);
const rowsPerPage = ref(5);
const columns = [
    { field: 'tutorName', header: 'Name', sortable: false },
    { field: 'tutorType', header: 'Type', sortable: false },
    { field: 'address', header: 'Address', sortable: false },
];
const onPageChange = (event) => {
    currentPage.value = event.page;
    rowsPerPage.value = event.rows;
};
</script>
<style scoped>
.p-datatable .p-column-header-content {
    justify-content: space-between;
}

.p-select {
    --p-select-sm-font-size: 12px;
    --p-select-color: var(--black-700);
    --p-select-hover-border-color: transparent;
    --p-select-border-color: transparent;
    --p-select-focus-border-color: transparent;
}

::v-deep(.p-select-sm .p-select-label) {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.black-btn {
    color: var(--gray-600) !important;
}

.black-btn:hover {
    color: var(--gray-600) !important;
    background-color: var(--black-50) !important;
}
</style>